import graphql__1d5b909c7f410284f31f from "./__generated__/DeleteCommentMutation.graphql.js";import { commitMutation, graphql } from "react-relay";

import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__1d5b909c7f410284f31f;

function deleteComment(commentId, onCompleted) {
  const variables = { commentId };

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { deleteComment };
